<template>
  <div>
    <b-modal
      id="confirmForceRemoveDay"
      modal-class="modal-cover"
      v-model="isVisible"
      hide-backdrop
      hide-footer
      content-class="shadow-lg modal-lg"
      centered
    >
      <section class="text-center">
        <b-row>
          <b-col cols="12" class="py-4">
            <h3 class="font-weight-bold title-text">
              ⚠️ {{ t('confirmForceActiveAccommodationTitle') }}
            </h3>
          </b-col>

          <b-col cols="12" class="py-3">
            <p class="message-text" style="white-space: pre-line;">
              {{ t('confirmForceActiveAccommodationBody') }}
              <br><br>
              <strong>{{ t('noteLabel') }}</strong> {{ t('confirmForceAddDayWarning') }}
            </p>
          </b-col>

          <b-col cols="12" class="py-4">
            <b-btn
              pill
              variant="danger"
              class="action-button mb-3"
              @click="forceRemoveDay"
            >{{ t('confirmForceAddDayConfirm') }}</b-btn>

            <b-btn
              pill
              variant="secondary"
              class="action-button"
              @click="closePopup"
            >{{ t('cancel') }}</b-btn>
          </b-col>
        </b-row>
      </section>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { translationMixin } from '@/mixins/translationMixin';

export default {
  mixins: [translationMixin],
  props: ["value"],
  data() {
    return {
      storedDayIndex: null,
      storedRemoveType: null // 'dayOnly' or 'dayAndAttractions'
    }
  },
  computed: {
    ...mapGetters(["inerModalParameters"]),
    isVisible: {
      set(val) {
        if (val === true) {
          // Always update stored values when modal opens
          if (this.inerModalParameters?.dayIndex !== undefined) {
            this.storedDayIndex = this.inerModalParameters.dayIndex;
            this.storedRemoveType = this.inerModalParameters.removeType || 'dayOnly';
          }
        } else if (val === false) {
          // Clear stored values when modal closes
          this.storedDayIndex = null;
          this.storedRemoveType = null;
        }
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  watch: {
    // Ensure parameters are captured after modal actually renders
    value(newVal) {
      if (newVal === true) {
        this.$nextTick(() => {
          const params = this.$store.getters.inerModalParameters;
          if (params && params.dayIndex !== undefined) {
            this.storedDayIndex = params.dayIndex;
            this.storedRemoveType = params.removeType || 'dayOnly';
          } else {
            // Fallback to reading from computed property
            const computedParams = this.inerModalParameters;
            if (computedParams && computedParams.dayIndex !== undefined) {
              this.storedDayIndex = computedParams.dayIndex;
              this.storedRemoveType = computedParams.removeType || 'dayOnly';
            }
          }
        });
      }
    }
  },
  methods: {
    ...mapActions([
      "showModal",
    ]),
    async forceRemoveDay() {
      // Safety check - ensure we have the required values
      if (this.storedDayIndex === null || this.storedDayIndex === undefined) {
        this.showModal("");
        this.closePopup();
        return;
      }
      
      const dayIndexValue = this.storedDayIndex;
      const removeTypeValue = this.storedRemoveType || 'dayOnly';
      
      this.showModal("loadingIcon");
      
      // Call the appropriate action based on stored remove type
      if (removeTypeValue === 'dayAndAttractions') {
        await this.$store.dispatch('removeDayAndAttractionsFromRide', {
          dayIndex: dayIndexValue,
          force: true
        });
      } else {
        await this.$store.dispatch('removeDayFromRide', {
          dayIndex: dayIndexValue,
          force: true
        });
      }
      
      this.closePopup();
    },
    closePopup() {
      this.showModal("");
    },
  },
};
</script>

<style scoped>
.modal.modal-cover .modal-content,
.modal.modal-cover .modal-footer,
.modal.modal-cover .modal-header {
  border: none;
}

.title-text {
  font-size: 24px;
  color: #D32F2F;
  margin-bottom: 20px;
}

.message-text {
  font-size: 18px;
  color: #2E2E3A;
  line-height: 1.6;
  margin: 0 auto;
  max-width: 85%;
}

.action-button {
  font-size: 18px;
  padding: 15px 30px;
  width: 80%;
  max-width: 500px;
  display: block;
  margin: 0 auto;
}

.action-button:hover {
  transform: translateY(-2px);
  transition: transform 0.2s ease;
}

.modal-lg {
  max-width: 600px;
}
</style>

